import { Radio } from '@fluentui/react-components';
import type { IField, IMetadata } from '@moko/utils';

interface RadioOptionsProps {
  metadata: IMetadata;
  field: IField;
}

export const RadioOptions = ({ metadata, field }: RadioOptionsProps) => {
  const lookup = metadata.lookups.find((l) => l.name === field.lookupList);
  if (!lookup) return null;

  return (
    <>
      {lookup.values.map((v) => (
        <Radio
          key={`${field.name}_${v.key}`}
          value={`${v.key}`}
          label={v.value}
        />
      ))}
    </>
  );
};
